"use client";

const SITE_LOCALE = process.env.NEXT_PUBLIC_SITE_LOCALE || "ru";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang={SITE_LOCALE}>
      <body style={{ margin: 0, background: "#09090b", color: "#fafafa", fontFamily: "Inter, system-ui, sans-serif" }}>
        <div style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "24px",
          padding: "24px",
          textAlign: "center",
        }}>
          {/* Icon */}
          <div style={{
            width: 64,
            height: 64,
            borderRadius: 16,
            background: "rgba(234, 179, 8, 0.1)",
            border: "1px solid rgba(234, 179, 8, 0.2)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}>
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#eab308" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
          </div>

          {/* Text */}
          <div>
            <h1 style={{ fontSize: 20, fontWeight: 600, margin: "0 0 8px" }}>
              Что-то пошло не так
            </h1>
            <p style={{ fontSize: 14, color: "#a1a1aa", maxWidth: 360, margin: "0 auto", lineHeight: 1.6 }}>
              Произошла непредвиденная ошибка. Мы уже работаем над её устранением.
            </p>
            {error.digest && (
              <p style={{ fontSize: 11, fontFamily: "ui-monospace, monospace", color: "rgba(161, 161, 170, 0.5)", marginTop: 12, userSelect: "all" }}>
                ID: {error.digest}
              </p>
            )}
          </div>

          {/* Button */}
          <button
            onClick={reset}
            style={{
              height: 40,
              padding: "0 24px",
              borderRadius: 12,
              background: "#eab308",
              color: "#09090b",
              border: "none",
              fontSize: 14,
              fontWeight: 500,
              cursor: "pointer",
              transition: "opacity 0.2s",
            }}
            onMouseOver={(e) => (e.currentTarget.style.opacity = "0.9")}
            onMouseOut={(e) => (e.currentTarget.style.opacity = "1")}
          >
            Попробовать снова
          </button>

          {/* Footer */}
          <p style={{ position: "absolute", bottom: 24, fontSize: 11, color: "rgba(161, 161, 170, 0.4)" }}>
            Tvorix AI
          </p>
        </div>
      </body>
    </html>
  );
}
